module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// ./node_modules/entities/lib/maps/xml.json
// module id = hrZQ
// module chunks = 1